import React from 'react';

export default function ListaDeRequerimentos(props) {
	const { listaDeRequerimentos, onSelect } = props;

	return (
		<div>
			<h5 className="my-0 text-dark">
				<strong>
                    Selecione o Requerimento base para o Termo de Compromisso
				</strong>
			</h5>

			<table className="table table-striped table-hover">
				<thead>
					<tr>
						<th>CPF</th>
						<th>Nome</th>
						<th>Matrícula</th>
						<th>Curso</th>
					</tr>
				</thead>

				<tbody>
					{
						listaDeRequerimentos.map(requerimento => {
							return (
								<tr key={requerimento.id} onClick={() => onSelect(requerimento)}>
									<td>{requerimento.aluno.cpf}</td>
									<td>{requerimento.aluno.nome}</td>
									<td>{requerimento.aluno.matricula}</td>
									<td>{requerimento.aluno.curso.nome}</td>
								</tr>
							);
						})
					}
				</tbody>
			</table>
		</div>
	);
}
